import WrenchIcon from "@heroicons/react/20/solid/WrenchIcon";

import { useGetDisplayMode, useSetDisplayMode } from "queries/admin-queries";

import adminStyles from "../AdminPanel.module.scss";

import styles from "./DiagnosticToggle.module.scss";

export default function DiagnosticToggle() {
  const { data: displayMode } = useGetDisplayMode();
  const { mutate: setDisplayMode } = useSetDisplayMode();

  const isActive = displayMode === "diagnostic";

  return (
    <label
      className={[
        adminStyles.tool,
        adminStyles.halfTool,
        styles.outer,
        isActive && styles.active,
      ].join(" ")}
    >
      <div className={styles.mainRow}>
        <div>
          <div className={styles.titleRow}>
            <WrenchIcon className={styles.spannerIcon} />
            <p className={adminStyles.toolTitle}>Diagnostic mode</p>
          </div>
          <p className={adminStyles.toolDescription}>See metadata and issues</p>
        </div>

        <input
          checked={isActive}
          className={styles.checkbox}
          type="checkbox"
          onChange={(e) => {
            if (e.target.checked) {
              setDisplayMode({ mode: "diagnostic" });
            } else {
              setDisplayMode({ mode: "default" });
            }
          }}
        />
      </div>
    </label>
  );
}
